"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = overrideIconDimensionsForCustomIcon;

var _FileTypeIcon = require("../constants/FileTypeIcon");

function overrideIconDimensionsForCustomIcon(initialProps, passedInPropSize) {
  var iconSize = typeof passedInPropSize === 'number' ? passedInPropSize : _FileTypeIcon.ICON_SHIRT_SIZES[String(passedInPropSize).toLowerCase()];
  var iconProps = Object.assign({}, initialProps, {
    size: iconSize || _FileTypeIcon.ICON_SHIRT_SIZES['sm']
  });
  return iconProps;
}

module.exports = exports.default;